import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './GeniesPage.css'; // Reusing styles
import config from '../config';
import TokenStorage from '../utils/tokenStorage';

const TestSpnPage = () => {
    const { spnName } = useParams();
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const testConnection = async () => {
            setLoading(true);
            const token = TokenStorage.getAccessToken();

            if (!token) {
                setError("Authentication required.");
                setLoading(false);
                return;
            }

            const url = `${config.apiUrl}/api/test-spn-connection/${spnName}`;

            try {
                const response = await axios.get(url, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                setResult(response.data);
                setLoading(false);
            } catch (err) {
                console.error(`Error testing SPN connection for ${spnName}:`, err);
                const errorData = err.response ? JSON.stringify(err.response.data, null, 2) : err.message;
                setError(`Failed to test connection for ${spnName}. Details: ${errorData}`);
                setLoading(false);
            }
        };

        testConnection();
    }, [spnName]);

    if (loading) {
        return <div className="genies-container"><h2>Testing Connection...</h2></div>;
    }

    if (error) {
        return (
            <div className="genies-container">
                <h2>Connection Test Failed</h2>
                <div className="genie-card" style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                    <p><strong>SPN:</strong> {spnName}</p>
                    <p><strong>Error:</strong></p>
                    <code>{error}</code>
                </div>
            </div>
        );
    }

    return (
        <div className="genies-container">
            <h1>Connection Test Result</h1>
            {result && (
                <div className="genie-card" style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                    <p><strong>SPN:</strong> {result.spnName}</p>
                    <p><strong>Client ID:</strong> {result.clientId}</p>
                    <p><strong>Client Secret:</strong> {result.clientSecret}</p>
                    <p><strong>Status:</strong> {result.status}</p>
                    <p><strong>Query Result:</strong></p>
                    <code>{JSON.stringify(result.queryResult, null, 2)}</code>
                </div>
            )}
        </div>
    );
};

export default TestSpnPage;